import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppRoute, AppRouteQueryParam } from 'src/app/app.route';
import { AuthenticationStore } from 'src/app/core/authentication/authentication.store';

export const verifyParamsGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const authStore = inject(AuthenticationStore);

  const shareId = route.queryParamMap.get(AppRouteQueryParam.ShareId);
  const relationId = route.queryParamMap.get(AppRouteQueryParam.RelationId);

  if (!shareId || !relationId) {
    return router.createUrlTree(['/', AppRoute.PageNotFound]);
  }

  // Store the context for later use (e.g., when redirecting after 401)
  authStore.setContext(shareId, relationId);

  return true;
};
